var map = {
	"./close.svg": 1081,
	"./example.svg": 1082,
	"./eye.svg": 1083,
	"./form.svg": 1084,
	"./password.svg": 1085,
	"./table.svg": 1086,
	"./tree.svg": 1087,
	"./user.svg": 1088
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1080;


//////////////////
// WEBPACK FOOTER
// ./src/widgets/icons/svg nonrecursive \.svg$
// module id = 1080
// module chunks = 0